import { ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { NgbModal, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { CustomPaggerService } from 'projects/Autofacets-Core/src/app/common-services/custom-pagger.service';
import { ExcelService } from 'projects/Autofacets-Core/src/app/common-services/export-excel.service';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import * as Enums from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { DealerSpecialTool, DealerSpecialToolExcelData, DealerVehicaltype } from '../../../business-entities/dealer-special-tool-view-model';
import { SelectListItemViewModel } from '../../../business-entities/select-list-item-view-model';
import { UserDealersModel } from '../../../business-entities/dealer-details.model';
import { UserRoleMenu } from '../../../business-entities/user-role-menu.model';
import { DealerSpecialToolBusinessService } from './../../../business-services/dealer-special-tool.service';
import { DealerBusinessService } from './../../../business-services/dealer.service';
import { AddDealerSpecialToolComponent } from './add-dealer-special-too/add-dealer-special-tool/add-dealer-special-tool.component';
import { EditDealerSpecialToolComponent } from './edit-dealer-special-tool/edit-dealer-special-tool/edit-dealer-special-tool.component';
import { VehicleType } from '../../../business-entities/vehicle-list-view-model';
import { CheckListBusinessService } from 'projects/Administration/src/app/business-services/check-list.service';
import { Constant } from 'projects/Autofacets-Core/src/app/utils/constant';
@Component({
  selector: 'app-dealer-special-tool',
  templateUrl: './dealer-special-tool.component.html',
  styleUrls: ['./dealer-special-tool.component.css']
})
export class DealerSpecialToolComponent implements OnInit, OnDestroy {
  selectedDealerId: string = '';
  total$: Observable<number>;
  dealerSpecialToolList: DealerSpecialTool[];
  dealerList: Array<SelectListItemViewModel>;
  paginationSub: Subscription
  currentlagSub: Subscription
  excelExportData: DealerSpecialToolExcelData[];
  vehicalTypes: DealerVehicaltype = {
    PC: false,
    LCV: false,
    Truck: false,
    DealerId: '',
    vehicleTypes : ''
  };
  SelectedVehical: any;
  vehicalType = [
    { id: 1, name: 'PC', value: true },
    { id: 2, name: 'LCV', value: true },
    { id: 3, name: 'Truck/Bus', value: true },
  ];
  userRoleRightsDetails: UserRoleMenu;
  VehicleTypes: VehicleType[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  constructor(
    public dealerSpecialtoolService: DealerSpecialToolBusinessService,
    public dealerBusinessService: DealerBusinessService,
    private currentLanguageService: CurrentLanguage,
    private cd: ChangeDetectorRef,
    public pService: CustomPaggerService,
    private cookieservice: CookieService,
    private spinner: NgxSpinnerService,
    private excelService: ExcelService,
    private userService: UserDataService,
    private modalService: NgbModal,
    private checkListService: CheckListBusinessService
  ) {
    this.pService.pageSize = 10;
    this.pService.searchby = ['brandName', 'dealerName', 'partNumber', 'partDescription', 'partGroup', 'takeoutPartQuantity', 'totalPartQuantity', 'usedBy', 'partLocation'];
    this.pService.searchTerm = '';
  }

  onSort({ column, direction }: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    this.pService.sortColumn = column;
    this.pService.sortDirection = direction;
  }

  ngOnInit(): void {
    this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === Enums.ModuleNames.DealerSpecialTools);
    this.getUserDealers();
    this.GetAllVehicleTypes();
    this.pService.dataSource = [];
    this.cd.detectChanges();
    if (this.currentlagSub) {
      this.currentlagSub.unsubscribe();
    }
    this.currentlagSub = this.currentLanguageService.currentLanguage.subscribe(_x => {
       if (this.dealerSpecialtoolService.selectedId && this.dealerSpecialtoolService.isEdit) {
        this.dealerSpecialtoolService.isEdit = false;
        this.vehicalTypes.DealerId = this.dealerSpecialtoolService.selectedId;
        this.selectedDealerId = this.dealerSpecialtoolService.selectedId;
      }
      else this.vehicalTypes.DealerId = this.selectedDealerId

      this.getSpecialToolList(this.vehicalTypes);
    });


  }
  async GetAllVehicleTypes(): Promise<void> {
    await this.checkListService.getVehicleTypes().then(data => {
      if(localStorage.getItem("Theme") == Constant.BnhInterface){
        this.VehicleTypes = data.responseObject;
      }
      else{
        this.VehicleTypes = data.responseObject.filter(x => x.isDisplay);
      }
    });
  }
  async getUserDealers(){
    await this.dealerBusinessService.getUserDealersDropdown().then((response) => {
      this.dealerList = this.mapdealer(response.userDealersModel);
      this.dealerSpecialtoolService.dealerList = this.dealerList;
    })
  }

  mapdealer(array: UserDealersModel[]){
    let supperArray = [];
    if (array && array.length > 0) {

      array.forEach(element=>{

        let single = Object();
        single.value = element.dealerId
        single.text = element.dealerName

        supperArray.push(single);
      })
    }
    return supperArray;
  }

  onDealerSelected(dealerId: string) {
    this.vehicalTypes.DealerId= dealerId ?? '' ;
    this.selectedDealerId =this.vehicalTypes.DealerId;
    this.getSpecialToolList(this.vehicalTypes);
  }

  SerchByVehicalType() {
    this.vehicalTypes.DealerId = this.selectedDealerId;
    this.vehicalTypes.vehicleTypes = this.SelectedVehical;
    this.getSpecialToolList(this.vehicalTypes);
  }

  async getSpecialToolList(vehicalObj: DealerVehicaltype) {
    this.spinner.show();
    let language = this.cookieservice.get('userSelectedLanguage')
    const requestModel={
      DealerId:vehicalObj.DealerId,
      // PC:vehicalObj.PC,
      // Truck:vehicalObj.Truck,
      // LCV:vehicalObj.LCV,
      vehicleTypes:vehicalObj?.vehicleTypes?.toString(),
      LanguageCode:language
    }

    await this.dealerSpecialtoolService.getService(requestModel).then((response) => {
      this.excelExportData = this.ExcelDataMapping(response.specialToolList);
      this.pService.dataSource = response.specialToolList;
      this.paginationSub = this.pService.dealers$.subscribe(result => {
        this.dealerSpecialToolList = this.dealerSpecialToolMapping(result);
      });
    })
    this.spinner.hide();
  }

  private ExcelDataMapping(specialToollList: any) {
    let supperArray = [];
    if (specialToollList && specialToollList.length > 0) {
      specialToollList.forEach(element=>{
        let single = Object();
        single.Brand = element.brandName;
        single.dealerName=element.dealerName;
        single.partNumber=element.partNumber;
        single.PartDescription = element.partDescription;
        single.PartGroup = element.partGroup;
        single.Location = element.partLocation;
        single.Quantity = element.totalPartQuantity;
        single.TakeOutQuantity = element.takeoutPartQuantity;
        single.UsedBy = element.usedBy;
        single.IsActive = element.isActive;
        single.vehicleType = element.vehicleType;
        supperArray.push(single);
      })
    }
    return supperArray;
  }
  private dealerSpecialToolMapping(specialToollList: any) {
    let supperArray = [];
    if (specialToollList && specialToollList.length > 0) {

      for (let index = 0; index < specialToollList.length; index++) {
        const element = specialToollList[index];

        let single = Object();
        single.rowNumber = this.currentPageNumber(index);
        single.id = element.dealerSpecialToolId;
        single.brand = element.brandName;
        single.dealerId = element.dealerId;
        single.dealerName = element.dealerName;
        single.isActive = element.isActive;
        single.takeOutQuantity = element.takeoutPartQuantity;
        single.totalQuantity = element.totalPartQuantity;
        single.usedBy = element.usedBy;
        single.partDescription = element.partDescription;
        single.partGroup = element.partGroup;
        single.partImage = element.partImage === null ? './../../../assets/images/no-img.png' : element.partImage;
        single.partNumber = element.partNumber;
        single.location = element.partLocation;
        single.vehicleType = element.vehicleType;
        supperArray.push(single);
      }
    }
    return supperArray;
  }

  exportAsXLSX(): void {
    this.excelService.exportAsExcelFile(this.excelExportData, 'Dealer Special Tool Report');
  }

  formatter = (result: SelectListItemViewModel) => result.text.toUpperCase();

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => {
        return term === '' ? []
          : this.dealerList.filter(v => v.text.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10)
      })
    )

  setDealer(event: NgbTypeaheadSelectItemEvent) {
    event.preventDefault();
    this.selectedDealerId = event.item.value;
    this.dealerSpecialtoolService.selectedId = this.selectedDealerId
    this.vehicalTypes.DealerId = this.selectedDealerId;
    this.getSpecialToolList(this.vehicalTypes);
  }
  onAdd() {
    const modalref = this.modalService.open(AddDealerSpecialToolComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  onEdit(id: number) {
    this.dealerSpecialtoolService.DealerSpecialToolId = id
    const modalref = this.modalService.open(EditDealerSpecialToolComponent, { size: 'md', windowClass: 'EditPopup' });
    modalref.result.then((response) => {
      if (response.success) {
        this.ngOnInit();
      }
    });
  }
  handleResultSelected(result) {
    this.search = result;
  }
  /**
* Methid to generate auto row number based on per page size
* @param cIndex
*/
  private currentPageNumber(cIndex: number): number {
    let rtPageNumber = 0;
    if (this.pService.page === 1) {
      rtPageNumber = cIndex + 1;
    }
    else if (this.pService.page > 1) {
      rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
    }

    return rtPageNumber;
  }
  ngOnDestroy(): void {
    if (this.paginationSub) {
      this.paginationSub.unsubscribe();
    }
    this.currentlagSub.unsubscribe();
    this.pService.dealers$ = new BehaviorSubject<any[]>([]);
    this.pService.total$ = new BehaviorSubject<number>(0);
  }

}
